import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";
import styled from "styled-components";

import Toggle from "./Toggle.styled";
import ButtonText from "features/shared/components/buttons/submit-button/styles/ButtonText.styled";

interface QuestionSampleRootProps {
  toggleOpen: boolean;
}

const QuestionSampleRoot = styled.div<QuestionSampleRootProps>`
  margin-top: 0.5rem;

  ${SmallPrint} {
    margin-bottom: 8px;
  }

  img.sample-doc {
    display: block;
    width: 253px;
    height: 160px;
  }

  ${ButtonText} {
    text-align: left;
  }

  ${Toggle} {
    margin-bottom: ${({ toggleOpen }) => (toggleOpen ? "1rem" : "0")};
  }

  img.toggle {
    transform: rotate(${({ toggleOpen }) => (toggleOpen ? "180deg" : "0deg")});
  }

  img.sample-doc {
    display: ${({ toggleOpen }) => (toggleOpen ? "block" : "none")};
  }
`;
export default QuestionSampleRoot;
